export default "/WBTC.fdc84113643ebf9d9ba7274d2fd2ecf9.svg";